import { render, staticRenderFns } from "./DetailsFreeDayItem.vue?vue&type=template&id=6477aba0&scoped=true&"
import script from "./DetailsFreeDayItem.vue?vue&type=script&lang=js&"
export * from "./DetailsFreeDayItem.vue?vue&type=script&lang=js&"
import style0 from "./DetailsFreeDayItem.vue?vue&type=style&index=0&id=6477aba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6477aba0",
  null
  
)

export default component.exports